import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = { sourceLink: string; retryTrigger: number };

export const BacklogAiWorkCreationPanelEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-backlog-ai-work-creation-panel" */ './ui').then(
			(module) => module.BacklogAiWorkCreationPanelEntryPointComponent,
		),
	),
	getPreloadProps: ({ sourceLink, retryTrigger }: EntryPointParams) => ({
		extraProps: {
			sourceLink,
			retryTrigger,
		},
	}),
});
